var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressBar"},[_c('div',{staticClass:"outBar"},[_c('div',{staticClass:"innerBar",style:({width:_vm.innerBarWidth})})]),_c('div',{staticClass:"speed"},[_c('span',[_vm._v(_vm._s(_vm.current))]),_vm._v("/"+_vm._s(_vm.total)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }